import React from 'react';
import {
  FaRegThumbsUp,
  FaRegThumbsDown,
  FaCheckCircle,
  FaTimesCircle,
  FaRegClock,
} from 'react-icons/fa';
import './badgeResposta.css';

const MAPA_CORES = {
  SIM: 'success',
  NÃO: 'danger',
  CONFORME: 'success',
  'NÃO CONFORME': 'danger',
  PENDENTE: 'neutral',
};

const MAPA_ICONES = {
  SIM: FaRegThumbsUp,
  NÃO: FaRegThumbsDown,
  CONFORME: FaCheckCircle,
  'NÃO CONFORME': FaTimesCircle,
  PENDENTE: FaRegClock,
};

const normalizarValor = (valor) => valor?.toString().trim().toUpperCase();

const BadgeResposta = ({ valor }) => {
  const valorNormalizado = normalizarValor(valor);
  const classe = MAPA_CORES[valorNormalizado] || 'neutral';
  const Icone = MAPA_ICONES[valorNormalizado];

  return (
    <span className={`resposta-valor ${classe}`}>
      {Icone && <Icone className="resposta-icone" />}
      <span className="resposta-texto">{valor}</span>
    </span>
  );
};

export default BadgeResposta;
